import { useEffect, useState } from "react";
import { useSelector as useReduxSelector } from "react-redux";
import { useOverlayWatcher } from "web/react/hooks/use-overlay-watcher/use-overlay-watcher";
import { ReduxStoreState } from "web/redux/store";
import environment from "web/script/modules/environment";

export const COOKIE_SETTINGS_OVERLAY = "cookie-settings-banner-modal";

/**
 * Whether the cookie consent banner is currently asking the user to decide.
 *
 * Shared by the banner itself and by BannerContainer, which suppresses competing
 * banners and raises its stacking order while a decision is outstanding.
 */
export function useCookieConsentPending(): boolean {
    const consentConfirmed = useReduxSelector((state: ReduxStoreState) => {
        return state.cookieConsentReducer.consentConfirmed;
    });
    const settingsModalIsOpen = Boolean(useOverlayWatcher(COOKIE_SETTINGS_OVERLAY));

    // The consent slice reads cookies when it is first imported, which in Hypernova
    // happens once at process start with no request and no cookies, so the server
    // always decides consent is settled. Hold the banner back until mount so the
    // first client render agrees with the server HTML and hydration succeeds.
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);

    // we want to allow the user to browse the cookie policy page freely
    return (
        mounted &&
        !consentConfirmed &&
        !settingsModalIsOpen &&
        environment.get("pageSubType") !== "cookie_policy"
    );
}
